import { GridModel, GridPostParams } from "common/models/utility-models/list-utility.model";
import { AssignmentModel } from "../Assignments Model/assignment-data.model";

export class InvitedGridModel extends AssignmentModel { }

export class InvitedListingModel extends GridModel<InvitedGridModel> { }

export class InvitedGridParams extends GridPostParams {
    pageNumber: number = 1;
    pageSize: number = 10;
    search_text: string = '';
    assignment_id: number = 348;
    timeslot_id: string = '';
  }